"use client";
import {
  useCompositeItem
} from "./QZLXIDNP.js";
import {
  useToolbarContext
} from "./SOK7T35T.js";
import {
  createElement,
  createHook,
  createMemoComponent
} from "./3ORBWXWF.js";
import {
  __objRest,
  __spreadValues
} from "./4R3V3JGP.js";

// src/toolbar/toolbar-item.ts
var useToolbarItem = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useToolbarContext();
    store = store || context;
    props = useCompositeItem(__spreadValues({ store }, props));
    return props;
  }
);
var ToolbarItem = createMemoComponent((props) => {
  const htmlProps = useToolbarItem(props);
  return createElement("button", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  ToolbarItem.displayName = "ToolbarItem";
}

export {
  useToolbarItem,
  ToolbarItem
};
